import React from 'react';
import {
  EmailShareButton,
  FacebookMessengerShareButton,
  ViberShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  ViberIcon,
  WhatsappIcon,
} from 'react-share';
import { toast } from 'react-toastify';

const ShareModal = ({ url }) => {
  const customStyles = {
    top: '30%',
    borderRadius: '8px',
    zIndex: '100',
    padding: '10px',
  };

  return (
    <div
      class="modal fade"
      id="shareModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="shareModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style={customStyles}>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="shareModalLabel">
              Share Post
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ gap: '20px', marginTop: '20px' }}
            >
              <EmailShareButton url={url} subject="Check out this post">
                <EmailIcon size={32} round={true} />
              </EmailShareButton>
              <FacebookMessengerShareButton url={url}>
                <FacebookIcon size={32} round={true} />
              </FacebookMessengerShareButton>
              <ViberShareButton url={url}>
                <ViberIcon size={32} round={true} />
              </ViberShareButton>
              <WhatsappShareButton url={url}>
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', position: 'relative' }}>
              <input
                type="text"
                value={url}
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cacccf' }}
              />
              <span
                role="img"
                aria-label="copy"
                aria-labelledby="copy"
                style={{
                  fontSize: '20px',
                  cursor: 'pointer',
                  position: 'absolute',
                  right: '5px',
                  top: '20%',
                }}
                onClick={() => {
                  navigator.clipboard.writeText(url);
                  toast.success('Link copied to clipboard');
                }}
              >
                📋
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
